const priority = { paid: 1, pending: 2, approved: 3, played: 4, rejected: 5 };

export function sortRequests(requests) {
  return [...requests].sort((a, b) => priority[a.status] - priority[b.status]);
}
